/**
 *  @class
 *  @function FeaturedCollectionList
 */

if (!customElements.get('featured-collection-list')) {
  class FeaturedCollectionList extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.featured-collection-list--button'));
      this.imageMap = new Map();

      this.buttons.forEach((button) => {
        const image = button.querySelector('.featured-collection-list--image');
        if (image) {
          this.imageMap.set(button, image);
        }
      });

      this.addEventListener('mousemove', this.onMove.bind(this));

      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.setupAnimations();
      }

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          const button = e.target.closest('.featured-collection-list--button');
          if (button) {
            this.buttons.forEach((b) => b.classList.remove('active'));
            button.classList.add('active');
          }
        });
      }
    }
    onMove(event) {
      const button = event.target.closest('.featured-collection-list--button');
      if (!button) return;
      const image = this.imageMap.get(button);
      if (!image) return;
      const rect = button.getBoundingClientRect();
      image.style.transform = `translate3d(${event.clientX - rect.left}px, ${event.clientY - rect.top}px, 0px)`;
    }
    setupAnimations() {
      ScrollTrigger.batch(this.querySelectorAll('.featured-collection-list--span span'), {
        onEnter: (elements) => {
          gsap.to(elements, { y: 0, stagger: 0.1, ease: window.theme.settings.animation_easing });
        },
      });
    }
  }
  customElements.define('featured-collection-list', FeaturedCollectionList);
}
